export const LOCALES = ['en_US', 'ar_SA', 'fr_FR', 'de_DE', 'id_ID', 'it_IT', 'ms_MY', 'pt_PT', 'ru_RU', 'es_ES', 'es_MX', 'th_TH', 'vi_VN', 'fil_PH', 'sw_KE']
export const DEFAULT_LOCALE = LOCALES[0]
